// extracted by mini-css-extract-plugin
export default {"card":"styles_card__gNSZk"};